import React, { ReactNode } from 'react';
import {
    Box,
    Drawer as MuiDrawer,
} from '@mui/material';

interface DrawerProps {
    isOpen: boolean;
    children: ReactNode;
    width?: string;
    header: ReactNode;
    position?: 'right' | 'left';
}

export const Drawer: React.FC<DrawerProps> = ({
    isOpen,
    position = 'right',
    children,
    width = '30%',
    header
}) => {
    return (
        <MuiDrawer
            open={isOpen}
            anchor={position}
            sx={{
                '& .MuiDrawer-paper': {
                    width: { xs: '100%', sm: '50%', md: '40%', lg: width },
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box
                sx={{
                    height: '100vh',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        bgcolor: 'action.hover',
                        alignItems: 'center',
                    }}
                >
                    {header}
                </Box>
                <Box
                    sx={{
                        height: '100%',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                    }}
                >
                    {children}
                </Box>
            </Box>
        </MuiDrawer>
    );
};